"use strict";

exports.__esModule = true;
exports.labelSpacing = exports.labelFontSize = exports.getTextColor = exports.getBorderColor = exports.defaultSpacing = exports.defaultFontSize = void 0;

var getColor = function getColor(_ref) {
  var error = _ref.error,
      success = _ref.success,
      hasFocus = _ref.hasFocus,
      hasHover = _ref.hasHover,
      type = _ref.type;

  if (error) {
    return "error";
  }

  if (success && !error) {
    return "success";
  }

  if (hasFocus) {
    return type + "-focus";
  }

  if (hasHover) {
    return "border-hover";
  }

  return type;
};

var getBorderColor = function getBorderColor(props) {
  return getColor(Object.assign({
    type: "border"
  }, props));
};

exports.getBorderColor = getBorderColor;

var getTextColor = function getTextColor(props) {
  return getColor(Object.assign({
    type: "text"
  }, props));
};

exports.getTextColor = getTextColor;
var defaultFontSize = {
  fontSize: 3,
  lineHeight: 2
};
exports.defaultFontSize = defaultFontSize;
var defaultSpacing = {
  px: 1,
  py: 2
};
exports.defaultSpacing = defaultSpacing;
var labelFontSize = {
  fontSize: 2,
  lineHeight: 1
};
exports.labelFontSize = labelFontSize;
var labelSpacing = {
  px: 0,
  py: "4px"
};
exports.labelSpacing = labelSpacing;